import React from "react";

const RobotDisabledRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 2.79999L5.31034 2.79999C3.48209 2.79999 2 4.41955 2 6.41738V9.5826C2 10.0348 2.07594 10.4677 2.21465 10.8668M3.5 12.6472C3.93299 12.9948 4.29893 13.0827 4.85634 13.1662C5.00477 13.1885 5.15633 13.2 5.31035 13.2H10.6897C12.5179 13.2 14 11.5804 14 9.5826V6.41738C14 5.17876 13.4968 4.15201 12.6281 3.5",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2 6.79999C10.2 7.02091 10.3791 7.19999 10.6 7.19999C10.8209 7.19999 11 7.02091 11 6.79999C11 6.57908 10.8209 6.39999 10.6 6.39999C10.3791 6.39999 10.2 6.57908 10.2 6.79999Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2 6.79999C5.2 7.02091 5.37909 7.19999 5.6 7.19999C5.82091 7.19999 6 7.02091 6 6.79999C6 6.57908 5.82091 6.39999 5.6 6.39999C5.37909 6.39999 5.2 6.57908 5.2 6.79999Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0815 9.79999C10.0815 9.79999 9.25185 10.2148 8.0074 10.2148C7.2196 10.2148 6.59804 10.0486 6.24796 9.92656",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0833 2L2 14.0833",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(RobotDisabledRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;